import React from 'react';
import classnames from 'classnames';
import type { LabelHTMLAttributes } from 'react';
import type { FontStyleLabelProps, HideLabelProps } from './types';

type Ref = HTMLLabelElement;
type HTMLProps = LabelHTMLAttributes<Ref>;
interface Props extends HTMLProps, HideLabelProps, FontStyleLabelProps {
  /**
   * Displays label as field required.
   */
  required?: boolean;
  /**
  * Sets inline layout.
  */
  isInline?: boolean;
  /**
   * Hint text to show next to label
   */
  hint?: string | null;
}

const Label = React.forwardRef<Ref, Props>(({
  htmlFor,
  required = false,
  hideLabel = false,
  labelStyle = null,
  isInline = false,
  hint,
  children,
  ...other
}: Props, ref) => {
  const fontStyle = (): string => {
    if (labelStyle === 'bold') {
      return 'font-bold';
    } else if (labelStyle === 'italic') {
      return 'italic';
    }

    return '';
  };
  return (
    <label
      ref={ref}
      htmlFor={htmlFor}
      className={`block ${fontStyle()} ${classnames({ 'sr-only': hideLabel })} ${isInline ? 'whitespace-nowrap' : ''}`}
      {...other as Omit<HTMLProps, 'htmlFor'>}
    >
      {children}{required && <span>*</span>}
      {hint ? <span className={'not-italic font-light text-gray-500'}> - {hint}</span> : null}
    </label>
  );
});

Label.displayName = 'Label';

export default Label;
